"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsMutation = void 0;
const react_oauth_1 = require("@yanzi/react-oauth");
const react_query_1 = require("react-query");
const useModelsGroupId_1 = require("./useModelsGroupId");
const useModelsQuery_1 = require("./useModelsQuery");
function useModelsMutation(accountNumber, method, path, bodyMapper, mutates) {
    const [apiUrl] = useModelsQuery_1.useApiUrlState(useModelsQuery_1.DEFAULT_API_URL);
    const groupId = useModelsGroupId_1.useModelsGroupId(accountNumber);
    const { accessToken } = react_oauth_1.useOAuth();
    const queryCache = react_query_1.useQueryCache();
    return react_query_1.useMutation((vars) => __awaiter(this, void 0, void 0, function* () {
        if (!groupId) {
            throw new Error('No models group ID for account number: ' + accountNumber);
        }
        if (!accessToken) {
            throw new Error('Not authenticated using OAuth.');
        }
        const body = bodyMapper ? bodyMapper(vars) : vars;
        const stringPath = typeof path === 'string' ? path : path(vars);
        const res = yield fetch(`${apiUrl}/groups/${groupId}${stringPath}`, {
            method,
            headers: Object.assign({ Authorization: `Bearer ${yield accessToken.get()}` }, (body ? { 'Content-Type': 'application/json' } : {})),
            body: body ? JSON.stringify(body) : undefined,
        });
        if (!res.ok) {
            throw new Error(`Models mutation failed with status code ${res.status}`);
        }
        return res.json();
    }), {
        onSettled: () => {
            if (mutates === null || mutates === void 0 ? void 0 : mutates.featureCollection) {
                queryCache.invalidateQueries([
                    'models',
                    apiUrl,
                    `/feature-collections/${mutates.featureCollection}/geojson`,
                    groupId,
                ]);
            }
        },
        throwOnError: true,
    });
}
exports.useModelsMutation = useModelsMutation;
//# sourceMappingURL=useModelsMutation.js.map